/** Created by azhou on 2019/1/16.*/
<template>
  <div class="register-wrap">
    <div >
      <register-header  :type="sales"/>
      <p class="text-right base-wrap mb-3" v-if="headerTitle === '用户协议'">
        <a href="javascript:;" @click="$router.back()">返回上一页</a>
      </p>
      <div class="base-wrap content-wrap">
        <div class="text-white  pt-3 pb-3 bg-login">
          {{headerTitle}}
        </div>
          <el-alert :title="'拒绝理由：' + StoreBasicInfo.verify_remark + '，请更正后重新提交！'"
                    v-if="storeInfo.verify===0 && StoreBasicInfo.verify_remark"
                    type="error" show-icon center/>
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import RegisterHeader from './Comp/Header'
  export default {
    name: 'RegisterWrap',
    components: { RegisterHeader },
    watch: {
      storeInfo(to,from) {
        console.log(to,from,679)
      }
    },
    computed: {
      ...mapState(['StoreBasicInfo','storeInfo']),
      ...mapGetters(['storeInfo']),
      sales () {return this.$route.query.sales*1||0},
      headerTitle() {
        return this.$route.meta.navigateName
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/css/color.scss';
  .register-wrap {
    background: $bgBase;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-size: 100%;
  }

  .content-wrap{
    min-height: 500px;
    box-shadow: 0 0 3px 3px #ddd;
    background: #fff;
  }
  .container{
    width: 60%;
    margin: 0 auto;
    padding: 20px 0;
    margin-top: 6%;
    background-color: #fff;
    border-radius: 10px;
  }
</style>
